import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { updateProducto, get_productos_admin } from '../../../redux/actions/productos';
import { get_categorias } from '../../../redux/actions/categorias';  
import CreatableSelect from 'react-select/creatable';  

import { v4 as uuidv4 } from 'uuid';
import { MdAddPhotoAlternate, MdClose } from 'react-icons/md';
import Portal from '../../ui/Portal';
import styles from '../ProductFormModal.module.css';
import form from '../../../styles/shared/FormDialog.module.css';
import dialog from '../../../styles/shared/Dialog.module.css';
import { mediaUrl } from '../../../api/client';
import { selectProps } from '../productSelectStyles';


const EditProductModal = ({ producto, onClose, updateProducto, get_productos_admin, categorias, get_categorias }) => {
    const [editedProduct, setEditedProduct] = useState({ ...producto, newImages: [], removedImages: [] });
    const [selectedCategory, setSelectedCategory] = useState(
        producto.categoria ? { value: producto.categoria, label: producto.categoria } : null
    );
    const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(
        producto.seccion ? { value: producto.seccion, label: producto.seccion } : null
    );
    const [previewUrls, setPreviewUrls] = useState([]);
    const [, setImages] = useState([]);
    const [, setCurrentImageProgress] = useState(0);
    const [, setIsProcessingImage] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState('');

    // Escape cierra (salvo que lo use un selector abierto para cerrar su menú)
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && !event.defaultPrevented) onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    useEffect(() => {
        get_categorias();  
    }, [get_categorias]);

    useEffect(() => {
        if (selectedCategory) {
            const category = categorias.find(cat => cat.nombre === selectedCategory.value);
            if (category) {
                const sectionOptions = category.secciones.map(sec => ({
                    value: sec.nombre,
                    label: sec.nombre
                }));
                setSections(sectionOptions);

                // Set the initial section value
                const initialSection = sectionOptions.find(sec => sec.value === editedProduct.seccion);
                setSelectedSection(initialSection || null);
            }
        } else {
            setSections([]);
            setSelectedSection(null);
        }
    }, [selectedCategory, categorias, editedProduct.seccion]);
    
    useEffect(() => {
        // Initialize previewUrls with existing product images
        if (producto.images) {
            
            setPreviewUrls(producto.images.map(image => {
                const url = mediaUrl(image.image);
               
                return url;
            }));
        }
    }, [producto]);

    const handleCategoryChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'create-option') {
            // New category created
            setEditedProduct(prev => ({
                ...prev,
                categoria: newValue.value  // Save the new category
            }));
        } else {
            // Existing category selected
            setSelectedCategory(newValue);
            setEditedProduct(prev => ({
                ...prev,
                categoria: newValue ? newValue.value : null  // Save selected category
            }));
        }
    };


    const handleSectionChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'create-option') {
            // New section created
            setSections(prevSections => [
                ...prevSections,
                { value: newValue.value, label: newValue.value }  // Add the new section to the list
            ]);
            setSelectedSection({ value: newValue.value, label: newValue.value });
            setEditedProduct(prev => ({
                ...prev,
                seccion: newValue.value  // Save the new section
            }));
        } else {
            // Existing section selected
            setSelectedSection(newValue);
            setEditedProduct(prev => ({
                ...prev,
                seccion: newValue ? newValue.value : null  // Save selected section
            }));
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedProduct(prev => ({
            ...prev,
            [name]: name === 'observacion' ? value : (value === '' ? null : value)
        }));
    };
    
     const compressImage = (file, maxSizeMB, maxWidth, maxHeight) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    let width = img.width;
                    let height = img.height;
    
                    if (width > height) {
                        if (width > maxWidth) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        }
                    } else {
                        if (height > maxHeight) {
                            width *= maxHeight / height;
                            height = maxHeight;
                        }
                    }
    
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
    
                    const compressAndCheck = (quality) => {
                        setCurrentImageProgress(Math.min(100, 100 - (quality * 100)));
                        canvas.toBlob(
                            (blob) => {
                                if (blob.size > maxSizeMB * 1024 * 1024 && quality > 0.1) {
                                    compressAndCheck(quality - 0.1);
                                } else {
                                    const compressedFile = new File([blob], file.name, {
                                        type: 'image/webp',
                                        lastModified: Date.now(),
                                    });
                                    resolve(compressedFile);
                                }
                            },
                            'image/webp',
                            quality
                        );
                    };
    
                    compressAndCheck(0.7);
                };
                img.onerror = reject;
            };
            reader.onerror = reject;
        });
    };
    const handleImageChange = async (e) => {
        const fileInput = e.target;
        const file = fileInput.files[0];
        if (!file) return;
    
        setIsProcessingImage(true);
        setCurrentImageProgress(0);
    
        try {
            const maxSizeMB = 0.5;
            const maxWidth = 500;
            const maxHeight = 667;
    
            const compressedFile = await compressImage(file, maxSizeMB, maxWidth, maxHeight);
            setCurrentImageProgress(100);
    
            const webpFilename = file.name.replace(/\.[^/.]+$/, "") + ".webp";
            const renamedWebp = new File([compressedFile], webpFilename, { type: 'image/webp' });
    
            const previewUrl = URL.createObjectURL(renamedWebp);
    
            const newImage = { id: uuidv4(), file: renamedWebp, previewUrl };
    
            setImages(prev => [...prev, newImage]);
            setPreviewUrls(prev => [...prev, newImage.previewUrl]);
            setEditedProduct(prev => ({ ...prev, newImages: [...prev.newImages, renamedWebp] }));
        } catch (error) {
            console.error('Error compressing image:', error);
            setIsProcessingImage(false);
        } finally {
            setIsProcessingImage(false);
            fileInput.value = '';
        }
    };
    
    
    const handleRemoveImage = (index) => {
        const imageUrl = previewUrls[index];

        setEditedProduct(prev => {
            const newImages = [...prev.newImages];
            const removedImages = [...prev.removedImages];

            if (index < producto.images.length) {
                removedImages.push(producto.images[index].id); // Assuming each image has an `id`
            } else {
                newImages.splice(index - producto.images.length, 1);
            }

            return { ...prev, newImages, removedImages };
        });

        setPreviewUrls(prev => prev.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        const writableFields = [
            'seccion',
            'equipo',
            'marca',
            'descripcion',
            'cantidad',
            'estado',
            'fecha_vencimiento',
            'proveedor',
            'categoria',
            'observacion',
            'reservado',
        ];

        writableFields.forEach((key) => {
            const value = editedProduct[key];
            if (key === 'observacion') {
                formData.append(key, value ?? '');
                return;
            }
            if (value !== null && value !== undefined && value !== '') {
                formData.append(key, value);
            }
        });
    
        editedProduct.newImages.forEach((image) => {
            formData.append('new_images', image);
        });
    
        editedProduct.removedImages.forEach((imageId) => {
            formData.append('removed_images', imageId);
        });
    
        setSubmitting(true);
        setSubmitError('');
        try {
            const success = await updateProducto(producto.id, formData);
            if (success) {
                await get_productos_admin();
                onClose();
            } else {
                console.error('Error updating product');
                setSubmitError('No se pudieron guardar los cambios. Inténtalo de nuevo.');
            }
        } catch (error) {
            console.error('Error updating product:', error);
            setSubmitError('No se pudieron guardar los cambios. Inténtalo de nuevo.');
        } finally {
            setSubmitting(false);
        }
    };
    

    return (
        <Portal>
            <div className={form.overlay}>
                <div
                    className={styles.content}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="edit-product-title"
                >
                    <div className={styles.header}>
                        <h2 id="edit-product-title" className={styles.title}>Editar producto</h2>
                        <button type="button" className={styles.close} onClick={onClose} aria-label="Cerrar">
                            <MdClose aria-hidden="true" />
                        </button>
                    </div>
                    <form className={styles.form} onSubmit={handleSubmit}>
                        <div className={styles.body}>
                            <div className={styles.grid}>
                                <div className={form.field}>
                                    <label htmlFor="categoria" className={form.label}>Categoría</label>
                                    <CreatableSelect
                                        {...selectProps}
                                        inputId="categoria"
                                        placeholder="Elegir o crear"
                                        value={
                                            editedProduct.categoria
                                                ? { value: editedProduct.categoria, label: editedProduct.categoria }
                                                : null
                                        }
                                        onChange={handleCategoryChange}
                                        options={categorias.map(cat => ({
                                            value: cat.nombre,
                                            label: cat.nombre
                                        }))}
                                        formatCreateLabel={(inputValue) => `Crear categoría: ${inputValue}`}
                                    />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="seccion" className={form.label}>Sección</label>
                                    <CreatableSelect
                                        {...selectProps}
                                        inputId="seccion"
                                        placeholder="Elegir o crear"
                                        value={
                                            selectedSection
                                                ? { value: selectedSection.value, label: selectedSection.label }
                                                : null
                                        }
                                        onChange={handleSectionChange}
                                        options={sections}
                                        formatCreateLabel={(inputValue) => `Crear sección: ${inputValue}`}
                                    />
                                </div>
                                <div className={`${form.field} ${styles.full}`}>
                                    <label htmlFor="equipo" className={form.label}>Nombre</label>
                                    <input id="equipo" name="equipo" className={form.formInput} value={editedProduct.equipo||'Sin Nombre'} onChange={handleChange} placeholder="Nombre del producto" />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="marca" className={form.label}>Marca</label>
                                    <input id="marca" name="marca" className={form.formInput} value={editedProduct.marca||''} onChange={handleChange} placeholder="Marca" />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="proveedor" className={form.label}>Proveedor</label>
                                    <input id="proveedor" name="proveedor" className={form.formInput} value={editedProduct.proveedor||''} onChange={handleChange} placeholder="Proveedor" />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="cantidad" className={form.label}>Cantidad</label>
                                    <input
                                        id="cantidad"
                                        type="number"
                                        name="cantidad"
                                        min="0"
                                        className={form.formInput}
                                        value={editedProduct.cantidad ?? ''}
                                        onChange={handleChange}
                                        placeholder="Cantidad"
                                    />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="estado" className={form.label}>Estado</label>
                                    <input id="estado" name="estado" className={form.formInput} value={editedProduct.estado||''} onChange={handleChange} placeholder="Estado" />
                                </div>
                                <div className={form.field}>
                                    <label htmlFor="fecha_vencimiento" className={form.label}>Fecha de vencimiento</label>
                                    <input
                                        type="date"
                                        id="fecha_vencimiento"
                                        name="fecha_vencimiento"
                                        className={form.formInput}
                                        value={editedProduct.fecha_vencimiento ? editedProduct.fecha_vencimiento.split('T')[0] : ''}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={`${form.field} ${styles.full}`}>
                                    <label htmlFor="descripcion" className={form.label}>Descripción</label>
                                    <textarea id="descripcion" name="descripcion" className={`${form.formInput} ${styles.textarea}`} value={editedProduct.descripcion||''} onChange={handleChange} placeholder="Descripción" />
                                </div>
                                <div className={`${form.field} ${styles.full}`}>
                                    <label htmlFor="observacion" className={form.label}>Observación</label>
                                    <textarea
                                        id="observacion"
                                        name="observacion"
                                        className={`${form.formInput} ${styles.textarea}`}
                                        value={editedProduct.observacion || ''}
                                        onChange={handleChange}
                                        placeholder="Observación"
                                        maxLength={100}
                                        aria-describedby="observacion-hint"
                                    />
                                    <p id="observacion-hint" className={form.hint}>
                                        {(editedProduct.observacion || '').length}/100 caracteres
                                    </p>
                                </div>
                                <div className={`${form.field} ${styles.full}`}>
                                    <span className={form.label} id="imagenes-label">Imágenes</span>
                                    <div className={styles.images} role="group" aria-labelledby="imagenes-label">
                                        {previewUrls.map((url, index) => (
                                            <div key={url} className={styles.imagePreview}>
                                                <img src={url} alt={`Imagen ${index + 1}`} />
                                                <button
                                                    type="button"
                                                    className={styles.removeImage}
                                                    onClick={() => handleRemoveImage(index)}
                                                    aria-label={`Quitar imagen ${index + 1}`}
                                                    title="Quitar"
                                                >
                                                    <MdClose aria-hidden="true" />
                                                </button>
                                            </div>
                                        ))}
                                        <label className={styles.upload}>
                                            <input type="file" accept="image/*" className={styles.fileInput} onChange={handleImageChange} />
                                            <MdAddPhotoAlternate aria-hidden="true" />
                                            Agregar
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.footer}>
                            {submitError && <p className={`${form.formError} ${styles.error}`} role="alert">{submitError}</p>}
                            <div className={`${dialog.buttons} ${form.buttons} ${styles.buttons}`}>
                                <button type="button" className={dialog.cancelButton} onClick={onClose}>Cancelar</button>
                                <button type="submit" className={dialog.confirmButton} disabled={submitting}>
                                    {submitting ? 'Guardando...' : 'Guardar cambios'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Portal>
    );
};
const mapStateToProps = (state) => ({
    categorias: state.Categorias.categorias, 
});
export default connect(mapStateToProps, { updateProducto, get_categorias, get_productos_admin })(EditProductModal);
